<template>
  <CustomFormBaseElement
    :value="value"
    :question-input-visible="false"
    :summary-input-visible="false"
    :required-input-visible="false"
    :observations-input-visible="false"
    :show-pdf-visible="false"
    :disabled="disabled"
    @input="handleCustomFormBaseElementInput"
  />
</template>

<script>
import CustomFormBaseElement from '@/components/customForms/element/CustomFormBaseElement.vue'

export default {
  name: 'CustomFormHiddenElement',
  components: { CustomFormBaseElement },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    handleCustomFormBaseElementInput(value, key) {
      this.$emit('input', { ...this.value, [key]: value })
    },
  },
}

</script>
